import { connect } from 'react-redux';
import PrivacyPolicy from './PrivacyPolicy.component';
import technologies from 'app/store/technologies';

const { requestFooterPrivacyPolicy } = technologies.actions;
const mapStateToProps = () => ({

});
const mapDispatchToProps = {
  footerPrivacyPolicy: requestFooterPrivacyPolicy,
}
export default connect(mapStateToProps,
  mapDispatchToProps)(PrivacyPolicy);
